import React from "react";

import { List } from "@/components/organisms/List";
import { cn } from "@/components/ui/utils";
import { useSelectContext } from "./Select.hooks";

/**
 * A single selectable option inside `<Select.Options>`.
 *
 * `value` must be the full option object (same reference as in `data`).
 * The selection highlight is shown automatically when `value` matches the
 * current `Select` value via `getOptionKey`.
 */
export function SelectOption<T>({
  value,
  children,
  disabled,
  "data-testid": dataTestId,
}: {
  value: T;
  children?: React.ReactNode;
  disabled?: boolean;
  "data-testid"?: string;
}) {
  const { getOptionKey, value: selectedValue } = useSelectContext<T>();

  const isSelected =
    selectedValue != null &&
    getOptionKey(value) === getOptionKey(selectedValue);

  return (
    <List.Item<T>
      value={value}
      data-testid={dataTestId}
      className={cn(
        disabled && "opacity-[0.45] cursor-default pointer-events-none",
        isSelected && "text-primary! font-medium",
      )}
    >
      {children}
    </List.Item>
  );
}
